import React from "react";
import MainButton from "../../components/admin/landingpage/MainButton";
import FeaturesCard from "../../components/admin/landingpage/FeaturesCard";
import styles from "./HomeAdmin.module.css";
import Slider from 'react-infinite-logo-slider'
import FAQ from "../../components/admin/landingpage/FAQ";
import { NavLink } from "react-router-dom";

import dashBoardIcon from "../../assets/admin/icons/dashboard-icon.svg";
import cardIcon from "../../assets/admin/icons/card.svg";
import pickupIcon from "../../assets/admin/icons/pickup-icon.svg";
import webshopIcon from "../../assets/admin/icons/webshop.svg";
import listItemIcon from "../../assets/admin/icons/listitemcheck.svg";

import logo1 from "../../assets/admin/logos/logo1.png"
import logo2 from "../../assets/admin/logos/logo2.png"
import logo3 from "../../assets/admin/logos/logo3.png"
import logo4 from "../../assets/admin/logos/logo4.svg"
import logo5 from "../../assets/admin/logos/logo5.svg"
import logo6 from "../../assets/admin/logos/logo6.svg"
import logo7 from "../../assets/admin/logos/logo7.svg"
import logo8 from "../../assets/admin/logos/logo8.svg"

import faqImage from "../../assets/admin/images/faq_image.png"
import ctaImage from "../../assets/admin/images/cta_image.png"
import heroImage from "../../assets/admin/images/hero_image.png"
import sectionImage from "../../assets/admin/images/section_image.jpg";

const HomeAdmin = () => {
   return (
      <div className={styles.homeAdmin}>
         <section>
            <div className={`${styles["half-grid"]} mt-10 `}>
               <div className={`${styles["white-cont"]} py-60`}>
                     <h1>De eenvoudigste manier om jouw klanten online te laten bestellen.</h1>
                     <h3>Bied jouw klanten een naadloze bestelervaring, volledig afgestemd op de behoeften van jouw restaurant.</h3>
                     <a href="mailto:info@brandvisionx.be">
                        <MainButton>Probeer het gratis</MainButton>
                     </a>
               </div>
               <div className={`${styles["blue-cont-1"]} ${styles["full-height"]}`}>
                  <div className={styles["hero-image-container"]}>
                     <img src={heroImage} alt="Hero" className={styles["hero-image"]} />
                  </div>
               </div>
            </div>
         </section>

         <section id="features">
            <div className={`${styles["white-cont"]} py-60 px-60`}>
               <div className="g-1-2 gap-3">
                  <div className="g-5 a-s-s mobile-t-a-s">
                     <h1>Alles voor de online groei van jouw restaurant</h1>
                     <p>
                     Ons platform helpt restaurants en delicatessezaken hun aanbod eenvoudig online te beheren, met tools voor efficiëntie en professionaliteit.</p>
                  </div>
                  <div className="g-1-1 a-i-s">
                     <FeaturesCard icon={dashBoardIcon} title="Intuïtief dashboard" description="Beheer producten, bestellingen en betalingen vanuit één overzichtelijk dashboard."></FeaturesCard>
                     <FeaturesCard icon={pickupIcon} title="Efficiënt afhalen" description="Klanten plannen eenvoudig een afhaalmoment. Geen wachtrijen"></FeaturesCard>
                     <FeaturesCard icon={webshopIcon} title="Professionele webshop" description="Creëer een webshop die jouw zaak perfect weerspiegelt."></FeaturesCard>
                     <FeaturesCard icon={cardIcon} title="Veilig betalen" description="Klanten betalen direct via jouw webshop. Je ontvangt alles veilig en snel."></FeaturesCard>
                  </div>
               </div>
            </div>
         </section>
         <section>
            <div className={styles["half-grid"]}>
               <div className={`${styles["white-cont"]} mobile-t-a-s mobile-a-i-s py-60`}>
                     <h1>Alles onder controle, altijd.</h1>
                     <h3>Met ons dashboard heb je alles wat je nodig hebt op één plek. Geen gedoe, gewoon overzicht en efficiëntie.</h3>
                     <ul>
                        <li><img src={listItemIcon} alt="ListItemIcon"></img><p>Bestellingen beheren</p></li>
                        <li><img src={listItemIcon} alt="ListItemIcon"></img><p>Inzichten in je inkomsten</p></li>
                        <li><img src={listItemIcon} alt="ListItemIcon"></img><p>Product- en menubeheer</p></li>
                        <li><img src={listItemIcon} alt="ListItemIcon"></img><p>Meldingen en updates</p></li>
                     </ul>
                     <a href="mailto:info@brandvisionx.be">
                     <MainButton>Meer weten?</MainButton>
                     </a>
               </div>
               <div className={styles["blue-cont-2"]}>
                  <img src={sectionImage} alt="Section" className={styles["blue-cont-2-image"]} />
               </div>
            </div>
         </section>
         <section>
            <div className={styles["half-grid"]}>
               <div className={`${styles["blue-cont-1"]} ${styles["full-height"]} ${styles["mobile-order-2"]}`} />
               <div className={`${styles["white-cont"]} mobile-a-i-s mobile-t-a-s py-60`}>
                     <h1>Jouw menu, online in een handomdraai.</h1>
                     <h3>Bouw je eigen webshop, pas hem aan naar jouw stijl en bied je gerechten aan voor afhaal. Klanten kunnen makkelijk bestellen, betalen en een tijdslot kiezen. </h3>
                     <ul>
                        <li><img src={listItemIcon} alt="ListItemIcon"></img><p>Jouw menu, jouw stijl</p></li>
                        <li><img src={listItemIcon} alt="ListItemIcon"></img><p>Vlotte bestelervaring</p></li>
                        <li><img src={listItemIcon} alt="ListItemIcon"></img><p>Boost je verkoop</p></li>
                        <li><img src={listItemIcon} alt="ListItemIcon"></img><p>Online betalingen</p></li>
                     </ul>
                     <NavLink to="https://resto-online.be/demo">
                           <MainButton>Bekijk een voorbeeld</MainButton>
                     </NavLink>
               </div>
            </div>
         </section>
         <section>
         <div className={`${styles["white-cont"]} ${styles["a-i-c"]} py-60`}>
            <h1>Vertrouwd door toprestaurants</h1>
            <h3>Zij genieten al van een vlotte bestelwebshop, wanneer begin jij?</h3>
            <Slider
               duration={40}
               blurBorders={false}
               blurBorderColor={'#fff'}
               width="230px"
            >
               <Slider.Slide>
                  <img src={logo3} alt="logo3" style={{ width: '170px' }} />
               </Slider.Slide>
               <Slider.Slide>
                  <img src={logo1} alt="logo1" style={{ width: '170px' }} />
               </Slider.Slide>
               <Slider.Slide>
                  <img src={logo2} alt="logo2" style={{ width: '170px' }} />
               </Slider.Slide>
               <Slider.Slide>
                  <img src={logo3} alt="logo3" style={{ width: '170px' }} />
               </Slider.Slide>
               <Slider.Slide>
                  <img src={logo1} alt="logo1" style={{ width: '170px' }} />
               </Slider.Slide>
               <Slider.Slide>
                  <img src={logo2} alt="logo2" style={{ width: '170px' }} />
               </Slider.Slide>
            </Slider>
      </div>
         </section>

         <section id="faq">
         <div className={`py-10 px-10`}>
          <div className="g-1-2-start gap-2">
            <div className={`${styles["full-height"]}`}>
              <div className={`${styles["blue-cont"]} ${styles["h60per"]} mb-20`}>
                <h2>Veelgestelde vragen</h2>
                <p className="c-w">
                  Klaar om te starten, maar heb je nog vragen? Vind hier snel de
                  antwoorden! <br></br> <br></br>Heb je niet gevonden wat je zocht? Neem gerust 
                  &nbsp;<a href="/contact">contact</a> met ons op!
                </p>
              </div>
              <img src={faqImage} alt="FAQImage" className={`${styles["faqimg"]}`}/>
            </div>
            <div className={styles["white-cont"]}>
              <FAQ />
            </div>
          </div>
        </div>
      </section>
         <section>
            <div className={`py-10 px-10`}>
               <div className="g-2-1 gap-2">
                     <div className={`${styles["blue-cont"]} ${styles["full-height"]} ${styles["a-i-c"]} t-c d-f-c g-10`}>
                        <h2>Start vandaag nog met jouw eigen webshop</h2>
                        <p className="c-w">Breng jouw zaak online en geef je klanten de service die ze verdienen.</p>
                        <a href="mailto:info@brandvisionx.be">
                           <MainButton>Start gratis proefperiode</MainButton>
                        </a>
                     </div>
                     <img src={ctaImage} alt="CTAImage"></img>
               </div>
            </div>
         </section>  
      </div>
   );
};
 
export default HomeAdmin;